import { Routes, Route } from "react-router-dom";
import Layout from "@/components/Layout";
import Home from "@/pages/Home";
import ServicesIndex from "@/pages/ServicesIndex";
import ServicePage from "@/pages/ServicePage";
import LocationsIndex from "@/pages/LocationsIndex";
import ProvincePage from "@/pages/ProvincePage";
import CityPage from "@/pages/CityPage";
import ServiceCityPage from "@/pages/ServiceCityPage";
import { RegionsIndex, RegionPage } from "@/pages/RegionPages";
import SectorsIndex from "@/pages/SectorsIndex";
import SectorPage from "@/pages/SectorPage";
import InsightsIndex from "@/pages/InsightsIndex";
import InsightPage from "@/pages/InsightPage";
import AboutPage from "@/pages/AboutPage";
import NotFound from "@/pages/NotFound";
import LayoutFr from "@/components/LayoutFr";
import { FrHome, FrServices, FrService, FrCity, FrServiceCity } from "@/pages/FrPages";

export default function App() {
  return (
    <Routes>
      <Route element={<Layout />}>
        <Route index element={<Home />} />
        <Route path="/services" element={<ServicesIndex />} />
        <Route path="/services/:serviceSlug" element={<ServicePage />} />
        <Route path="/locations" element={<LocationsIndex />} />
        <Route path="/locations/:provinceSlug" element={<ProvincePage />} />
        <Route path="/locations/:provinceSlug/:citySlug" element={<CityPage />} />
        <Route path="/locations/:provinceSlug/:citySlug/:serviceSlug" element={<ServiceCityPage />} />
        <Route path="/regions" element={<RegionsIndex />} />
        <Route path="/regions/:regionSlug" element={<RegionPage />} />
        <Route path="/sectors" element={<SectorsIndex />} />
        <Route path="/sectors/:sectorSlug" element={<SectorPage />} />
        <Route path="/insights" element={<InsightsIndex />} />
        <Route path="/insights/:insightSlug" element={<InsightPage />} />
        <Route path="/about" element={<AboutPage />} />
        <Route path="*" element={<NotFound />} />
      </Route>
      <Route element={<LayoutFr />}>
        <Route path="/fr" element={<FrHome />} />
        <Route path="/fr/services" element={<FrServices />} />
        <Route path="/fr/services/:serviceSlug" element={<FrService />} />
        <Route path="/fr/villes/:citySlug" element={<FrCity />} />
        <Route path="/fr/villes/:citySlug/:serviceSlug" element={<FrServiceCity />} />
      </Route>
    </Routes>
  );
}
